export default __webpack_public_path__ + "static/media/phone.20f04949.svg";